import script from "./HeaderTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderTabs.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderTabs.vue?vue&type=style&index=0&id=7d8087af&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8087af"]])

export default __exports__